import { call, put, takeLatest } from "redux-saga/effects";
import { callHomePageLandingGetApi, callHomePagePostLoginLandingApi } from "../Context/homePageLandingApi";
import { onLandingHome, onLandingHomeError, onLandingHomePostLogin, onLandingHomePostLoginError, onLandingHomePostLoginSuccess, onLandingHomeSuccess } from "../Store/Slices/homePageLandingSlice";

function* HomePageLanding({payload}) {
  try {
    const getHomePageResponse = yield call(callHomePageLandingGetApi, payload);
    if (getHomePageResponse.responseCode === "200") {
      yield put(
        onLandingHomeSuccess({
          data: getHomePageResponse.response,
          message: getHomePageResponse.responseMessage,
          status_code:getHomePageResponse.responseCode
        })
      );
    } else {
      yield put(
        onLandingHomeError({
          data: getHomePageResponse.response,
          message: getHomePageResponse.response.message,
          status_code:getHomePageResponse.responseCode
        })
      );
    }
  } catch (error) {
    const message = error.response || "Something went wrong";
    yield put(onLandingHomeError({ data: [], message, status_code: 400 }));
  }
}
function* HomePageLandingPostLogin({payload}){
  try {
    const getHomePagePostLoginResponse = yield call(callHomePagePostLoginLandingApi, payload);
    if (getHomePagePostLoginResponse.responseCode === "200") {
      yield put(
        onLandingHomePostLoginSuccess({
          data: getHomePagePostLoginResponse.response,
          message: getHomePagePostLoginResponse.responseMessage,
          status_code:getHomePagePostLoginResponse.responseCode
        })
      );
    } else {
      yield put(
        onLandingHomePostLoginError({
          data: getHomePagePostLoginResponse.response,
          message: getHomePagePostLoginResponse.response.message,
          status_code:getHomePagePostLoginResponse.responseCode
        })
      );
    }
  } catch (error) {
    const message = error.response || "Something went wrong";
    yield put(onLandingHomePostLoginError({ data: [], message, status_code: 400 }));
  } 
}
export default function* homePageLandingSaga() {
  yield takeLatest(onLandingHome.type, HomePageLanding);
  yield takeLatest(onLandingHomePostLogin.type, HomePageLandingPostLogin);
}

    
